import { STATUS_ACTIVE } from '@/constants/constants'
import {
  isProPlan,
  isTeamPlan,
  PLAN_MONTHLY,
} from '@/constants/userSubscriptionPlans'

export const isActiveMonthlyPlan = (
  planId: string | null,
  planType: string,
  subscriptionStatus: string
) =>
  (isProPlan(planId) || isTeamPlan(planId)) &&
  planType === PLAN_MONTHLY &&
  subscriptionStatus === STATUS_ACTIVE
